interface StatusBadgeProps {
  color: 'emerald' | 'red' | 'amber' | 'blue' | 'gray';
  label: string;
}

const colorClasses: Record<StatusBadgeProps['color'], { bg: string; text: string }> = {
  emerald: { bg: 'bg-emerald-500/20', text: 'text-emerald-500' },
  red: { bg: 'bg-red-500/20', text: 'text-red-500' },
  amber: { bg: 'bg-amber-500/20', text: 'text-amber-500' },
  blue: { bg: 'bg-blue-500/20', text: 'text-blue-500' },
  gray: { bg: 'bg-gray-500/20', text: 'text-gray-500' },
};

export function StatusBadge({ color, label }: StatusBadgeProps) {
  const classes = colorClasses[color];
  if (!classes) return null;

  return (
    <div className="mt-1 flex items-center gap-x-1.5">
      <div className={`flex-none rounded-full ${classes.bg} p-1`}>
        <div className={`size-1.5 rounded-full ${classes.text.replace('text-', 'bg-')}`}></div>
      </div>
      <p className={`text-xs/5 ${classes.text}`}>{label}</p>
    </div>
  );
}
